import { render, staticRenderFns } from "./settings.html?vue&type=template&id=33fa5b62&scoped=true&external"
import script from "./settings.js?vue&type=script&lang=js&external"
export * from "./settings.js?vue&type=script&lang=js&external"
import style0 from "./settings.scss?vue&type=style&index=0&id=33fa5b62&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33fa5b62",
  null
  
)

export default component.exports